// require('./components/homeSlider.js');
// require('./components/foxy.js');

// require('./pages/auctionPreview.js');
// require('./components/uts.js');
// require('./components/main.js');

// TEST (this works, trying to break it into smaller pieces)
// require('./test/agg-uts.js');
// require('./test/agg-main.js');

// Rework
require("./vendor/jquery.cycle.js");
require("./vendor/fancybox.js");
require("./vendor/cloudzoom.js");
require("./vendor/cloudzoom.thumbelina.js");
require("./vendor/posthog.js");

require("./components/main.js");
require("./components/forms");
